module.exports = __webpack_public_path__ + "img/inner3.e8587326.png";